export class CheckableItem<Data> {
    public data: Data;
    public checked: boolean;

    constructor(data: Data) {
        this.data = data;
        this.checked = false;
    }
    check() {
        this.checked = true;
    }
}